import UserStore from './userStore.js'
import AppStore from './appStore.js'

export default {
  userStore: new UserStore(),
  appStore: new AppStore()
}
